import { useMemo } from 'react';
import { useSiteDocuments } from '@/hooks/sites/useSiteDocuments';
import { updateDocumentCategory } from '@/hooks/submissions/useSubmissionDocuments';
import DocumentsTable, {
  getDocumentStatusBadge,
  type DocumentWithStatus,
} from '@/components/DocumentsTable';

const SiteDocumentsContent = ({
  siteId,
  compact,
}: {
  siteId: string;
  compact?: boolean;
}) => {
  const { documents, isLoading, error, refetch } = useSiteDocuments(siteId);

  const documentsWithStatus: DocumentWithStatus[] = useMemo(() => {
    return documents.map(doc => {
      const badge = getDocumentStatusBadge(doc.document_status);
      return {
        ...doc,
        statusLabel: badge.label,
        statusClassName: badge.className,
      };
    });
  }, [documents]);

  const handleCategoryUpdate = async (
    documentId: string,
    submissionId: string,
    category: string
  ) => {
    await updateDocumentCategory(submissionId, documentId, category);
    await refetch();
  };

  return (
    <DocumentsTable
      documents={documentsWithStatus}
      isLoading={isLoading}
      error={error}
      onRetry={refetch}
      onCategoryUpdate={handleCategoryUpdate}
      collectionZipRoute={`/sites/${siteId}/documents/zip`}
      compact={compact}
    />
  );
};

export default SiteDocumentsContent;
